import { useEffect, useState } from 'react';
import { Api } from '@infra/api';
import { Analyses } from '@domain/models';
import { Modal } from '../components/Modal';
import { SearchSelect } from '../components/SearchSelect';
import { DataTable } from '../components/DataTable';

type Deviation = {
  id?: number;
  analysis_id: number;
  context_id?: number | null;
  unit_id?: number | null;
  severity: string; // normal_deviation | serious
  description: string;
  rule_code?: string | null;
  is_active?: boolean;
};

const empty: Deviation = { analysis_id: 0, severity: 'normal_deviation', description: '' };

export function DeviationsPage() {
  const [analyses, setAnalyses] = useState<Analyses[]>([]);
  const [form, setForm] = useState<Deviation>(() => {
    const saved = localStorage.getItem('deviations_page_analysis_id');
    const analysisId = saved ? Number(saved) : 0;
    return { ...empty, analysis_id: analysisId };
  });
  const [list, setList] = useState<Deviation[]>([]);
  const [selected, setSelected] = useState<Deviation | null>(null);

  useEffect(() => {
    Api.listAnalyses().then(a => {
      setAnalyses(a);
      const savedAnalysisId = localStorage.getItem('deviations_page_analysis_id');
      const analysisId = savedAnalysisId ? Number(savedAnalysisId) : (a[0]?.id ?? 0);
      const validAnalysisId = a.find(a => a.id === analysisId) ? analysisId : (a[0]?.id ?? 0);
      if (validAnalysisId > 0) {
        setForm(f => ({...f, analysis_id: validAnalysisId}));
        load(validAnalysisId);
      }
    });
  }, []);

  async function load(analysisId: number) {
    const d = await Api.listDeviationsByAnalysis(analysisId);
    setList(d as any);
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const created = await Api.createDeviation(form);
    setList([created, ...list]);
    setForm({ ...empty, analysis_id: form.analysis_id });
  }

  async function saveSelected() {
    if (!selected || !selected.id) return;
    const updated = await Api.updateDeviation(selected.id, selected);
    setList(list.map(i => (i.id === updated.id ? updated : i)));
    setSelected(null);
  }

  return (
    <div>
      <div className="toolbar">
        <div className="title"><h2 style={{margin:0}}>Отклонения</h2></div>
      </div>
      <div className="row">
        <form className="card" onSubmit={submit} style={{maxWidth:720}}>
          <h3 style={{marginTop:0}}>Новое правило</h3>
          <label>Анализ</label>
          <SearchSelect
            options={analyses.map(a=>({ value: a.id ?? 0, label: a.analyses_name }))}
            value={form.analysis_id}
            onChange={(v)=>{
              const id = Number(v);
              setForm({...form, analysis_id:id});
              load(id);
              localStorage.setItem('deviations_page_analysis_id', String(id));
            }}
          />
          <label>Серьёзность</label>
          <select value={form.severity} onChange={e=>setForm({...form, severity:e.target.value})}>
            <option value="normal_deviation">normal_deviation</option>
            <option value="serious">serious</option>
          </select>
          <label>Описание</label>
          <input value={form.description} onChange={e=>setForm({...form, description:e.target.value})} required />
          <label>Код правила (опц.)</label>
          <input value={form.rule_code ?? ''} onChange={e=>setForm({...form, rule_code:e.target.value})} />
          <div style={{marginTop:12}}>
            <button>Создать</button>
          </div>
        </form>

        <div style={{flex:2}}>
          <DataTable
            data={list}
            title="Список"
            searchFields={["severity", "description", "rule_code"] as any}
            searchPlaceholder="Поиск по описанию, типу, коду..."
            onRowClick={(item)=>setSelected(item)}
            columns={[
              { key: 'severity', title: 'Severity' },
              { key: 'description', title: 'Description' },
              { key: 'rule_code', title: 'Rule' },
            ]}
          />
        </div>
      </div>

      {selected && (
        <Modal title={`Отклонение #${selected.id}`} onClose={()=>setSelected(null)}>
          <div>
            <label>Серьёзность</label>
            <select value={selected.severity} onChange={e=>setSelected({...selected!, severity:e.target.value})}>
              <option value="normal_deviation">normal_deviation</option>
              <option value="serious">serious</option>
            </select>
            <label>Описание</label>
            <input value={selected.description} onChange={e=>setSelected({...selected!, description:e.target.value})} />
            <label>Код правила</label>
            <input value={selected.rule_code ?? ''} onChange={e=>setSelected({...selected!, rule_code:e.target.value})} />
            <div style={{marginTop:12, display:'flex', gap:8}}>
              <button onClick={saveSelected}>Сохранить</button>
              <button className="secondary" onClick={()=>setSelected(null)}>Отмена</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}


